<div
  class="mx-auto flex text-sm text-red-600"
  [class.justify-center]="centerAlign">
  <mat-icon class="mr-1 min-w-[24px]">error_outline</mat-icon>
  <span class="flex flex-wrap content-center">
    {{ errorText }}
  </span>
</div>
